import React from "react";
import { DEFAULT_BACKGROUND_COLOR_HEX, DEFAULT_EMOJI, DEFAULT_SHOW_BUBBLES, Emoji } from "../constants/theme";

interface IThemeContext {
  emoji: Emoji;
  backgroundColorHex: string;
  showBubbles: boolean;
  updateEmoji: (newEmoji: Emoji) => void;
  updateBackgroundColorHex: (newValue: string) => void;
  updateShowBubbles: (newValue: boolean) => void;
}

export const DEFAULT_THEME_CONTEXT: IThemeContext = {
  emoji: DEFAULT_EMOJI,
  backgroundColorHex: DEFAULT_BACKGROUND_COLOR_HEX,
  showBubbles: DEFAULT_SHOW_BUBBLES,
  updateEmoji: () => null,
  updateBackgroundColorHex: () => null,
  updateShowBubbles: () => null,
}

const ThemeContext = React.createContext<IThemeContext>(DEFAULT_THEME_CONTEXT);

export default ThemeContext;
